import { useContext, useMemo } from 'react';
import SessaoUsuarioContext from '../../contexts/SessaoUsuarioContext';
import AppContext from '../../contexts/AppContext';

interface AlertaDeErroDeProcessamentoProps {
  modulo?: string;
  consideraErroDeModulo?: boolean;
  consideraErroDeAmbiente?: boolean;
}

export const AlertaDeErroDeProcessamento = ({ modulo, consideraErroDeModulo, consideraErroDeAmbiente }: AlertaDeErroDeProcessamentoProps) => {
  const { sessao } = useContext(SessaoUsuarioContext);
  const { estaAtualizando, ambiente: { atualizacoes, erro } } = useContext(AppContext);

  const shouldUseModulo = modulo ? true : !!consideraErroDeModulo;
  const shouldUseAmbiente = consideraErroDeAmbiente === undefined ? true : !!consideraErroDeAmbiente;

  const temErroDeModulo = useMemo(() => {
    if (modulo) {
      return atualizacoes?.filter(m => m.modulo === modulo)[0]?.status === 'Failed';
    }
    return atualizacoes?.some(x => x.status === 'Failed') === true;
  }, [atualizacoes, modulo]);

  const temErroDeAmbiente = useMemo(() => {
    if (shouldUseModulo && shouldUseAmbiente) return temErroDeModulo || !!(erro || '').trim();
    if (shouldUseModulo) return temErroDeModulo;
    if (shouldUseAmbiente) return !!(erro || '').trim();
    return false;
  }, [temErroDeModulo, erro, shouldUseModulo, shouldUseAmbiente]);

  if (!(sessao && !estaAtualizando && temErroDeAmbiente)) return null;

  return (
    <section className='painel-info'>
      <div className='painel-error-loading'>
        <span>
          Não conseguimos processar seus dados. Entre em contato com o suporte para que possamos te ajudar.
        </span>
      </div>
    </section>
  );
};
